module.exports = __webpack_public_path__ + "static/10-b780698d888c872cfe3c36cf6ccc2c4e.jpg";